interface TwivaMarkProps {
  /** Tailwind size classes, e.g. "h-6 w-6". Parent controls the box. */
  className?: string;
}

/**
 * The Twiva four-block mark — the modular "building blocks" from the brand
 * book's Tetris system. Rendered with divs (no SVG) so it themes with the
 * active palette.
 */
export default function TwivaMark({ className = 'h-6 w-6' }: TwivaMarkProps) {
  return (
    <span
      className={`grid grid-cols-2 grid-rows-2 gap-[3px] ${className}`}
      aria-hidden="true"
    >
      <span className="rounded-[3px] bg-primary-500" />
      <span className="rounded-[3px] bg-secondary-500" />
      <span className="rounded-[3px] bg-accent-500" />
      <span className="rounded-[3px] bg-foreground-900" />
    </span>
  );
}